var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeys({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2367 22.3436C20.3522 22.1896 21.4259 21.8156 22.3956 21.2432L29.381 28.2272C30.2189 29.0364 31.5507 29.0248 32.3744 28.2012C33.198 27.3775 33.2096 26.0457 32.4004 25.2078L25.4107 18.2238C27.3828 14.8836 26.8564 10.6339 24.129 7.87571C21.4016 5.11755 17.158 4.54356 13.7959 6.47804",
    stroke: "#228800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0838 13.8794C18.0826 9.44098 14.6823 5.74303 10.2595 5.37038C5.83677 4.99774 1.8656 8.0746 1.12183 12.4503C0.378067 16.8259 3.10958 21.0421 7.40707 22.1517V30.8867C7.40707 32.066 8.36309 33.022 9.5424 33.022C10.7217 33.022 11.6777 32.066 11.6777 30.8867V22.1517C15.4497 21.1778 18.0847 17.7751 18.0838 13.8794Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54688 10.6902V4.20301C9.54688 2.43404 10.9809 1 12.7499 1C14.5189 1 15.9529 2.43404 15.9529 4.20301V5.61091",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54549 14.9699C10.7248 14.9699 11.6808 14.0139 11.6808 12.8346C11.6808 11.6552 10.7248 10.6992 9.54549 10.6992C8.36618 10.6992 7.41016 11.6552 7.41016 12.8346C7.41016 14.0139 8.36618 14.9699 9.54549 14.9699Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeys);
export default __webpack_public_path__ + "assets/media/keys.644b1c57bacedcf64a099b5261f09bd3.svg";
export { ForwardRef as ReactComponent };